// extracted by mini-css-extract-plugin
var _1 = "dhHlrbk2";
var _2 = "dhHlrbk2";
export { _1 as "price-range-facet", _2 as "priceRangeFacet" }
